export const HOME = {
  UA: "https://hostiq.ua/ukr/",
  RU: "https://hostiq.ua/",
  EN: "https://hostiq.ua/eng/charity-hosting/"
};
export const SERVICE_TERMS = {
  UA: "https://hostiq.ua/ukr/acceptable-use-policy/",
  RU: "https://hostiq.ua/acceptable-use-policy/",
  EN: "https://hostiq.ua/eng/acceptable-use-policy/"
};
export const PUBLIC_OFFER = {
  UA: "https://hostiq.ua/ukr/tos/",
  RU: "https://hostiq.ua/tos/",
  EN: "https://hostiq.ua/eng/tos/"
};
export const PRIVACY_POLICY = {
  UA: "https://hostiq.ua/ukr/privacy-policy/",
  RU: "https://hostiq.ua/privacy-policy/",
  EN: "https://hostiq.ua/eng/privacy-policy/",
};
export const DOMAINS = {
  UA: "https://hostiq.ua/ukr/domains/",
  RU: "https://hostiq.ua/domains/",
};
export const MIRROR_DOMAINS = {
  UA: "https://hostiq.ua/wiki/ukr/mirror-domains/",
  RU: "https://hostiq.ua/wiki/mirror-domains/",
};
export const FAQ_TRADE_MARK = {
  UA: "https://hostiq.ua/wiki/ukr/faq-trade-mark-registration/",
  RU: "https://hostiq.ua/wiki/faq-trade-mark-registration/",
  EN: "https://hostiq.ua/wiki/ukr/faq-trade-mark-registration/",
};
export const RESET_PASSWORD = "https://hostiq.ua/clients/pwreset.php";
export const SSL = {
  UA: "https://hostiq.ua/ukr/ssl/",
  RU: "https://hostiq.ua/ssl/",
  EN: "https://hostiq.ua/ukr/ssl/",
};
export const FAQ_HOSTING_DNS = {
  UA: "https://hostiq.ua/wiki/ukr/faq-public-hosting-dns/",
  RU: "https://hostiq.ua/wiki/faq-public-hosting-dns/",
  EN: "https://hostiq.ua/wiki/ukr/faq-public-hosting-dns/",
};
